"use client";
import * as React from 'react';
import { IconButton } from '../../IconButton/IconButton.web.js';
import styled from 'styled-components';
import { ContentText } from '../../ContentText/ContentText.web.js';
import { useTheme } from '../../utils/theming/useTheme.js';
import { px2rem } from '../../utils/helpers/style.js';

var StyledButton = /*#__PURE__*/styled(IconButton).withConfig({
  displayName: "NPSButtonweb__StyledButton",
  componentId: "sc-v82rl2-0"
})(["&:not(:first-child){margin-left:2px;}"]);
var NPSButton = function NPSButton(_ref) {
  var score = _ref.score,
    buttonScore = _ref.buttonScore,
    onClick = _ref.onClick,
    color = _ref.color;
  var handleClick = React.useCallback(function () {
    return onClick(buttonScore);
  }, [onClick, buttonScore]);
  var theme = useTheme();
  return /*#__PURE__*/React.createElement(StyledButton, {
    "data-testid": "elemental-NPS-button-".concat(buttonScore),
    key: buttonScore,
    color: score >= buttonScore ? color || theme.nps.web.color : theme.nps.web.background,
    icon: /*#__PURE__*/React.createElement(ContentText, {
      color: score < buttonScore ? theme.colors.text : theme.nps.web.background
    }, buttonScore),
    onClick: handleClick,
    flexGrow: 1,
    flexShrink: 1,
    width: px2rem(40),
    height: px2rem(40),
    padding: 0
  });
};

export { NPSButton };
